import * as React from 'react';

import { config } from '@common/config';
import Constants from 'src/_constants/Constants';

import { TutorialComponent } from 'src/tutorial/tutorial.component';

export const AutoAuthoTutorial = () => (
  <>
    <div className="row center-xs">
      <div className="col">
        <TutorialComponent
          tutorialHeader="Auto-Authorization Tutorial"
          mp4URL={config.tutorialURL + Constants.tutorialFiles.AUTOAUTHO_MP4}
          jpegURL={config.tutorialURL + Constants.tutorialFiles.AUTOAUTHO_JPG}
        />
      </div>
    </div>
  </>
);



// WEBPACK FOOTER //
// ./src/tutorial/autoauthotutorial.component.tsx